export const BsInfo = ({ ...props }) => (
	<svg  data-testid="BsInfo-4CDE33" {...props} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 3C5.85813 3 2.5 6.35813 2.5 10.5C2.5 14.6419 
  5.85813 18 10 18C14.1419 18 17.5 14.6419 17.5 10.5C17.5 
  6.35813 14.1419 3 10 3ZM10.9376 14.25C10.9376 14.7675 10.5175 
  15.1874 10.0001 15.1874C9.4826 15.1874 9.06258 14.7674 9.06258 
  14.25V9.56245C9.06258 9.04495 9.4826 8.62496 10.0001 
  8.62496C10.5175 8.62496 10.9376 9.04498 10.9376
   9.56245V14.25ZM9.06258 6.76501C9.06258 7.28248 9.48257 
   7.7025 10.0001 7.7025C10.5176 7.7025 10.9376 7.28248 10.9376 
   6.76501C10.9376 6.24754 10.5175 5.82753 10.0001 5.82753C9.4826 5.82753
    9.06258 6.24754 9.06258 6.76501Z"
			fill="white"
		/>
	</svg>
);
